var map = {
	"./AveragePoints.png": 6987,
	"./FinalizingConsecutively.png": 2465,
	"./HatTricks.png": 7952,
	"./HotLaps.png": 5440,
	"./Podiums.png": 6560,
	"./Points.png": 9242,
	"./Poles.png": 7806,
	"./Races.png": 6945,
	"./Titles.png": 8557,
	"./Wins.png": 1506,
	"./WithdrawnConsecutively.png": 7868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8580;